// extracted by mini-css-extract-plugin
module.exports = {"BoxItems":"BoxItems_BoxItems__2ZiA2"};